export default "__VITE_ASSET__B_6mIzh7__"